export default __webpack_public_path__ + "static/media/metaMask.32cf3192.svg";